import { connect } from 'react-redux'
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'

import { closeModalTravelRenewal } from '../../../actions/purchaseActions'
import { formatURL } from '../../../utils';

export class ModalTravelRenewal extends Component {
    constructor(props) {
        super(props)
        this.goToSearchPage = this.goToSearchPage.bind(this);
    }

    goToSearchPage() {
        const location = {
            pathname: formatURL(
                this.props.match,
                `/pesquisa/${this.props.match.params.destination}/${this.props.match.params.begin_date}/${this.props.match.params.end_date}/`,
                window.location.search
            ),
        }
        this.props.closeModalTravelRenewal();
        this.props.history.replace(location);
    }

    render() {
        if (!this.props.isModalTravelRenewalActive)
            return <div />

        return (
            <div className="comp_modalpagamento quotationDateWarning-modal franchise-modal" onClick={this.props.closeModalTravelRenewal}>
                <div className="modalcontents" onClick={ e => e.stopPropagation()}>
                    <div onClick={this.props.closeModalTravelRenewal} className="close-btn"> &times; </div>
                    <div className="contents">
                        <div className="modalmiddle">
                            <h3>Atenção! Este plano é específico para quem <br/> já está em viagem!</h3>

                            <p className="text-middle">
                              Se este não for o seu caso, clique em Voltar à Pesquisa para escolher um outro plano. <br/> Para prosseguir, clique em Continuar.
                            </p>
                        </div>
                        <div className="choosecontainer">
                            <div className="optionone">
                                 <button className="button" onClick={this.goToSearchPage}>
                                       <span>Voltar à pesquisa</span>
                                 </button>
                            </div>
                        </div>
                        <div className="choosecontainer continue">
                            <div className="optionone">
                                 <button className="button" onClick={this.props.closeModalTravelRenewal}>
                                       <span>Continuar</span>
                                 </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

export default connect(
    state => ({
        isModalTravelRenewalActive: state.purchase.isModalTravelRenewalActive,
    }),
    {
      closeModalTravelRenewal
    }
)(withRouter(ModalTravelRenewal));



// WEBPACK FOOTER //
// ./src/components/purchase/modal_travel_renewal/ModalTravelRenewal.jsx